import { render, staticRenderFns } from "./MassiveProductTypeDialog.vue?vue&type=template&id=8850a108&lang=pug&"
import script from "./MassiveProductTypeDialog.vue?vue&type=script&lang=js&"
export * from "./MassiveProductTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports